import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import GranteeProfileInfo from '../../../widgets/granteeProfileInfo/GranteeProfileInfo'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getContractGranteeInfo } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getGranteeForStaff } from '../../../redux/actions/granteeForStaff'

export default function checkFundRecipients() {
  //ขั้นที่ 1 ตรวจสอบข้อมูลผู้ขอทุน
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getGranteeForStaff(proposalId)
      console.log('res => ', _schema)
      setSchema(_schema)
    } catch (e) {
      console.log(e)
    }

    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load checkFundRecipients proposal', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={'ขั้นที่ 1 ตรวจสอบคุณสมบัติผู้รับทุน'} subHeader={schema?.subHeader} />

        {schema.forms.granteeProfile && <GranteeProfileInfo schema={schema.forms.granteeProfile} />}

        <br />
        {schema?.forms?.responsinatorProfile && (
          <>
            <GranteeProfileInfo schema={schema?.forms?.responsinatorProfile} />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
